import type { PieChartComponentSpec } from "../Processing/types";
import type { ControlPanelHandler } from "../widgetContract";
import { isBound, seriesDatePatch } from "./_shared";

// PieSeriesBuilderMisc has no `inheritPlayers` flag.
export const pieControlPanel: ControlPanelHandler<PieChartComponentSpec> = (spec, patch) => {
  for (const ser of spec.series) {
    ser.series_builder_misc = {
      ...ser.series_builder_misc,
      ...(patch.applyDate && !isBound(ser.series_builder_misc, "date", patch) && seriesDatePatch(patch.date)),
      ...(patch.applySubjects && !isBound(ser.series_builder_misc, "subject", patch) && patch.subjects),
    };
  }
};
